import { useData } from "./DataProvider";
import { loadServizi, type Servizio } from "./gare";
import { useAsync } from "../lib/useAsync";

/** Servizi gara (elenco piccolo): servono per sigle, filtri e moduli. */
export function useServizi() {
  const data = useData();
  const r = useAsync(() => loadServizi(data), [data]);
  const byId = new Map((r.data ?? []).map((s) => [s.id, s]));
  return { ...r, servizi: r.data, byId };
}

export const etichettaServizio = (s?: Servizio) => (s ? `${s.fields.Sigla} – ${s.fields.Title}` : "—");
